package nl.astraeus.wiki.ws

import kotlinx.browser.window
import nl.astraeus.wiki.domain.User
import nl.astraeus.wiki.log
import nl.astraeus.wiki.mainView
import nl.astraeus.wiki.messages.*
import nl.astraeus.wiki.service.UserService
import nl.astraeus.wiki.view.LoadingSplash
import org.w3c.dom.MessageEvent
import org.w3c.dom.WebSocket
import org.w3c.dom.events.Event
import org.w3c.files.Blob

fun sendMessageWithSpinner(msg: Message, handler: (Message) -> Unit) {
  val splash = LoadingSplash.load()
  WebsocketConnection.send(msg) { response ->
    handler.invoke(response)
    splash.done()
  }
}

fun sendMessage(msg: Message, handler: (Message) -> Unit) {
  WebsocketConnection.send(msg) { response ->
    handler.invoke(response)
  }
}

object WebsocketConnection {
  private var onOpenCB: () -> Unit = {}
  private var splash: LoadingSplash? = null
  private val callbacks = mutableMapOf<String, (Message) -> Unit>()
  private var nextId = 0

  var websocket: WebSocket? = null
  var loadingCalls: Int = 0
  var interval: Int = 0

  var handlers: MutableMap<MessageType, (WebSocket, Message) -> Unit> = mutableMapOf(
    MessageType.LOGIN_SUCCESS to { ws, msg ->
      val lsm = LoginSuccessfulMessage(msg.message)
      UserService.currentUser = User(
        lsm.getHeader(MessageHeader.OBJECT_ID).toLong(),
        lsm.getHeader(MessageHeader.EMAIL),
        lsm.getHeader(MessageHeader.USERNAME),
        ""
      )
      mainView.requestUpdate()
    },
    MessageType.PING to { _, _ -> }
  )

  private fun openSplash() {
    check(splash == null) {
      "Splash already open"
    }
    splash = LoadingSplash.load()
  }

  private fun closeSpash() {
    splash?.done()
    splash = null
  }

  fun open(onOpenCB: () -> Unit) {
    this.onOpenCB = onOpenCB
    close()

    console.log("creating websocket")
    websocket =
      if (window.location.hostname.contains("localhost") || window.location.hostname.contains("192.168")) {
        WebSocket("ws://${window.location.hostname}:${window.location.port}/ws")
      } else {
        WebSocket("wss://${window.location.hostname}/ws")
      }

    websocket?.also { ws ->
      ws.onopen = {
        console.log("websocket.onopen", ws)
        onOpen(ws)
        onOpenCB()
      }
      ws.onmessage = { onMessage(ws, it) }
      ws.onclose = { onClose(ws, it) }
      ws.onerror = { onError(ws, it) }
    }
  }

  fun close() {
    websocket?.close(-1, "Application closed socket.")
  }

  fun onOpen(
    ws: WebSocket,
  ) {
    interval = window.setInterval({
      val actualWs = websocket

      if (actualWs != null) {
        sendMessage(PingMessage(), {})
      } else {
        openSplash()

        window.clearInterval(interval)
        //MainView.logout()

        //Modal.showAlert("Error", "Connection to the server was lost!\nPlease try again later.")
        log.debug { "Connection to the server was lost!\\nPlease try again later." }
        open(onOpenCB)
      }
    }, 10000)
  }

  fun onClose(
    ws: WebSocket,
    event: Event
  ): dynamic {
    websocket = null
    closeSpash()

    return "dynamic"
  }

  fun onError(
    ws: WebSocket,
    event: Event
  ): dynamic {
    log.debug { "Error websocket! $ws" }

    websocket = null
    closeSpash()

    window.setTimeout(open(onOpenCB), 2000)

    return "dynamic"
  }

  fun onMessage(
    ws: WebSocket,
    event: Event
  ) {
    if (event is MessageEvent) {
      val data = event.data

      if (data is String) {
        val message = Message(data)

        val cb = callbacks[message.getHeader(MessageHeader.MESSAGE_ID)]
        if (cb != null) {
          callbacks.remove(message.getHeader(MessageHeader.MESSAGE_ID))

          cb(message)
        } else {
          handlers[message.getMessageType()]?.invoke(ws, message) ?: console.warn(
            "Unknown message: ",
            message
          )
        }
      } else if (data is Blob) {
        error("We don't do binary messages...")
      }
    }
  }

  fun connected(): Boolean {
    log.debug { "Connected: ${websocket?.readyState == WebSocket.OPEN}" }

    return websocket?.readyState == WebSocket.OPEN
  }

  fun send(msg: Message, cb: (Message) -> Unit) {
    val id = ++nextId
    msg.setHeader(MessageHeader.MESSAGE_ID, id.toString())

    // console.log("Sending message3: ", msg)

    callbacks[id.toString()] = cb

    websocket?.send(msg.message)
  }

}
